import { render, staticRenderFns } from "./activity2.vue?vue&type=template&id=32855562&scoped=true&"
import script from "./activity2.vue?vue&type=script&lang=js&"
export * from "./activity2.vue?vue&type=script&lang=js&"
import style0 from "./activity2.vue?vue&type=style&index=0&id=32855562&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32855562",
  null
  
)

export default component.exports